import { SelectionModel } from '@angular/cdk/collections';import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output, signal, ViewChild, WritableSignal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CountableTimeZonePipe } from 'countable@helpers';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged, finalize, Subject, Subscription, takeUntil } from 'rxjs';
import { SharedService } from 'src/app/components/shared/shared.service';
import { IClientData, IExportData } from 'src/app/model/export-data.model';
import { ExportPlatformService } from 'src/app/services/export-platform.service';
import { CoreModule } from '../../../../core/core.module';
import { SharedModule } from '../../../shared/shared.module';

@Component({
    selector: 'app-custom-data-export',
    templateUrl: './custom-data-export.component.html',
    styleUrls: ['./custom-data-export.component.scss'],
    standalone: true,
    imports: [SharedModule, CommonModule, CoreModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomDataExportComponent implements OnInit, OnDestroy {
    @Output() goBack = new EventEmitter<boolean>();
    @Output() spinnerConfig = new EventEmitter<boolean>(null);
    masterData: IExportData[] = [];
    filteredEngData: IExportData[] = [];
    columnDefs: any;
    public allSubscriptions = new Subscription();
    private readonly unSubscribe$: Subject<void> = new Subject<void>();
    displayedColumns: string[] = ['select', 'clientName', 'engagementType', 'engagementName', 'financialYearEndDate', 'partnerName'];
    dataSource: MatTableDataSource<IExportData> = new MatTableDataSource<IExportData>();
    @ViewChild(MatSort) sort: MatSort;
    selection = new SelectionModel<IExportData>(true, []);
    viewEngagements = false;
    masterClientData: IClientData[] = [];
    nonSelectedClientData: IClientData[] = [];
    filteredNonSelClient: IClientData[] = [];
    selectedClientData: IClientData[] = [];
    filteredSelectedClient: IClientData[] = [];
    columnFilterData: any;
    selectedFilter: any;
    loadEngGrid = true;
    clientCount: number;
    engCount: number;
    searchAllClient: FormControl;
    searchSelectClient: FormControl;
    searchEngagement: FormControl;
    yearsList: string[] = [];
  public hasNoEngagements: WritableSignal<boolean> = signal<boolean>(false);

    constructor(
        private exportPlatformService: ExportPlatformService,
        private toaster: ToastrService,
        private sharedService: SharedService,
        private countableTimeZonePipe: CountableTimeZonePipe,
        private cdr: ChangeDetectorRef

    ) { }


    ngOnInit() {
        this.searchAllClient = new FormControl();
        this.searchSelectClient = new FormControl();
        this.searchEngagement = new FormControl();

        this.searchAllClient.valueChanges.pipe(
            debounceTime(1000)
            , distinctUntilChanged()
        ).subscribe((text: string) => {
            this.onSearchAllClient();
        });

        this.searchSelectClient.valueChanges.pipe(
            debounceTime(1000)
            , distinctUntilChanged()
        ).subscribe((text: string) => {
            this.onSearchSelecetedClient();
        });

        this.searchEngagement.valueChanges.pipe(
            debounceTime(1000)
            , distinctUntilChanged()
        ).subscribe((text: string) => {
            this.onSearchEngagement();
        });

        this.columnDefs = {
            clientName: "Client Name",
            engagementType: "Engagement Type",
            engagementName: "Engagement ID",
            financialYearEndDate: "Year End",
            partnerName: "Partner",
        };

        this.columnFilterData = this.sharedService.createAppliedFilterObject(this.displayedColumns);
        this.selectedFilter = this.sharedService.createAppliedFilterObject(this.displayedColumns);
        this.getClients();
    }

    getClients() {
        this.spinnerConfig.emit(true);
        this.allSubscriptions.add(
            this.exportPlatformService.getClientsData().pipe(
                takeUntil(this.unSubscribe$),
                distinctUntilChanged(),
                finalize(() => this.spinnerConfig.emit(false))
            ).subscribe({
                next: (response: any) => {
                    if (response && response.data && response.data.length) {
                        this.masterClientData = response.data.map(ele => {
                            return { clientId: ele.clientId, clientName: ele.clientName, isChecked: false };
                        });
                        this.nonSelectedClientData = JSON.parse((JSON.stringify(this.masterClientData)));
                        this.filteredNonSelClient = JSON.parse((JSON.stringify(this.masterClientData)));
                    }
                    else {
                        this.masterClientData = [];
                        this.nonSelectedClientData = [];
                        this.filteredNonSelClient = [];
                    }
                    this.cdr.detectChanges();
                },
                error: (error: any) => {
                    this.toaster.error(error.error);
                }
            })
        );
    }

    getExportData(clientIds: string) {
        this.yearsList = [];
        this.engCount = 0;
        this.spinnerConfig.emit(true)
        this.allSubscriptions.add(
            this.exportPlatformService.getExportData('custom', clientIds).pipe(
                takeUntil(this.unSubscribe$),
                distinctUntilChanged(),
                finalize(() => this.spinnerConfig.emit(false))
            ).subscribe({
                next: (response: any) => {
                    if (response && response.data && response.data.length) {
                        response.data.forEach(ele => {
                            this.yearsList.push(this.countableTimeZonePipe.transform(ele.financialYearEndDate, "yyyy"));
                            ele.financialYearEndDate = this.countableTimeZonePipe.transform(ele.financialYearEndDate, "MMM dd, yyyy", 'UTC');
                        });
                        this.masterData = JSON.parse(JSON.stringify(response.data));
                        this.engCount = response.data.length;
                        //create filters
                        this.displayedColumns.forEach(ele => {
                            if(ele === 'financialYearEndDate'){
                                const yearFilter: any[] = [];
                                [...new Set(this.yearsList)].forEach(x => {
                                    yearFilter.push({value : x, isChecked: false});
                                })
                                this.columnFilterData[ele] = [...yearFilter];
                            }else{
                                this.columnFilterData[ele] = this.sharedService.getColumnFilterData(this.masterData, ele);
                            }
                        });

                        this.filteredEngData = JSON.parse(JSON.stringify(this.masterData));
                        this.dataSource = new MatTableDataSource(this.filteredEngData);
                        this.dataSource.sort = this.sort;
                        this.hasNoEngagements.set(false);
                    } else {
                        this.engCount = 0;
                        this.masterData = [];
                        this.filteredEngData = [];
                        this.hasNoEngagements.set(true);
                    }
                    this.loadEngGrid = false;
                    this.cdr.detectChanges();
                },
                error: (error: any) => {
                    this.engCount = 0;
                    this.loadEngGrid = false;
                    this.toaster.error(error.error);
                  this.hasNoEngagements.set(true);
                }
            })
        );
    }

    clearFilter(colKey: string){
        this.selectedFilter[colKey] = [];
        this.columnFilterData[colKey].forEach(ele =>{
            ele.isChecked = false;
        })
        this.filteredEngData = JSON.parse(JSON.stringify(this.sharedService.getFilteredGridData(this.masterData, this.selectedFilter)));
        this.dataSource = new MatTableDataSource(this.filteredEngData);
        this.dataSource.sort = this.sort;
    }

    onFilterChanged(colKey: string, col: any, isChecked: boolean) {
        col.isChecked = isChecked;
        if (isChecked) {
            if(colKey === 'financialYearEndDate'){
                const list = this.masterData.filter(ele => ((ele.financialYearEndDate).toString()).includes(col.value)).map(e => e.financialYearEndDate);
                this.selectedFilter[colKey] = [...this.selectedFilter[colKey], ...list];
            }else{
                this.selectedFilter[colKey].push(col.value);
            }
        } else {
            if(colKey === 'financialYearEndDate'){
                const list = this.selectedFilter[colKey].filter(ele => !ele.includes(col.value));
                this.selectedFilter[colKey] = [...list];
            }else{
                const index = this.selectedFilter[colKey].indexOf(col.value);
                this.selectedFilter[colKey].splice(index, 1);
            }
        }
        this.filteredEngData = JSON.parse(JSON.stringify(this.sharedService.getFilteredGridData(this.masterData, this.selectedFilter)));
        this.dataSource = new MatTableDataSource(this.filteredEngData);
        this.dataSource.sort = this.sort;
    }

    onBtnExport() {
        const copyData = JSON.parse(JSON.stringify(this.selection.selected));
        copyData.forEach(ele => {
            ele.financialYearEndDate = this.countableTimeZonePipe.transform(ele.financialYearEndDate, "YYYY-MM-DD", 'UTC');
        });
        this.exportPlatformService.exportData(copyData);
        //this.exportPlatformService.navigateToHistoryTab$.next(true);
    }


    onViewEngagements() {
        this.viewEngagements = true;
        this.clientCount = this.selectedClientData.length;
      this.selection?.clear();
      this.searchEngagement.setValue('');
      this.searchEngagement.reset();
      this.searchEngagement.updateValueAndValidity();
        const clientIds = this.selectedClientData.map(ele => ele.clientId).join(',');
        this.getExportData(clientIds);
    }

    onSearchAllClient() {
        if (this.searchAllClient.value && this.searchAllClient.value.trim().length) {
            const filteredData = this.nonSelectedClientData.filter(ele => ele.clientName.toLowerCase().indexOf(this.searchAllClient.value.toLowerCase()) > -1);
            this.filteredNonSelClient = JSON.parse(JSON.stringify(filteredData));
        }
        else {
            this.filteredNonSelClient = JSON.parse(JSON.stringify(this.nonSelectedClientData));
        }
    }

    onSearchSelecetedClient() {
        if (this.searchSelectClient.value && this.searchSelectClient.value.trim().length) {
            const filteredData = this.selectedClientData.filter(ele => ele.clientName.toLowerCase().indexOf(this.searchSelectClient.value.toLowerCase()) > -1);
            this.filteredSelectedClient = JSON.parse(JSON.stringify(filteredData));
        }
        else {
            this.filteredSelectedClient = JSON.parse(JSON.stringify(this.selectedClientData));
        }
    }

    singleCheck(data, clientId, isChecked) {
        const index = data.findIndex(ele => ele.clientId === clientId);
        if (index > -1) {
            data[index].isChecked = isChecked;
        }
    }

    toggleSelection(data, isChecked, type: 'selected' | 'nonselected') {
        data.forEach(ele => {
            ele.isChecked = isChecked;
            if (type === 'nonselected') {
                const ind = this.nonSelectedClientData.findIndex(cl => cl.clientId === ele.clientId);
                this.nonSelectedClientData[ind].isChecked = isChecked;
            } else {
                const ind = this.selectedClientData.findIndex(cl => cl.clientId === ele.clientId);
                this.selectedClientData[ind].isChecked = isChecked;
            }
        });
    }

    onSearchEngagement() {
      this.dataSource.filter = this.searchEngagement.value?.trim()?.toLowerCase();
    }

    moveToSelected() {
        const selected = JSON.parse(JSON.stringify(this.filteredNonSelClient.filter(ele => ele.isChecked)));
        const checkedIds: number[] = selected.map(ele => ele.clientId);
        this.nonSelectedClientData = JSON.parse(JSON.stringify(this.nonSelectedClientData.filter(ele => !(checkedIds.includes(ele.clientId)))));
        selected.forEach(ele => ele.isChecked = false);
        this.selectedClientData = [...this.selectedClientData, ...selected];
        this.onSearchAllClient();
        this.onSearchSelecetedClient();
    }

    moveFromSelected() {
        const selected = JSON.parse(JSON.stringify(this.filteredSelectedClient.filter(ele => ele.isChecked)));
        const checkedIds: number[] = selected.map(ele => ele.clientId);
        this.selectedClientData = JSON.parse(JSON.stringify(this.selectedClientData.filter(ele => !(checkedIds.includes(ele.clientId)))));
        selected.forEach(ele => ele.isChecked = false);
        this.nonSelectedClientData = [...this.nonSelectedClientData, ...selected];
        this.onSearchAllClient();
        this.onSearchSelecetedClient();
    }

    isMoveToSelectedDisabled() {
        return this.nonSelectedClientData.every(ele => !ele.isChecked);
    }

    isMoveFromSelectedDisabled() {
        return this.selectedClientData.every(ele => !ele.isChecked);
    }

    isExportDataDisabled() {
        return this.selection.selected.length ? false : true;
    }

    isAllSelected() {
        return ((this.selection.selected.length !== 0) && (this.selection.selected.length === this.dataSource.data.length));
    }

    masterToggle() {
        this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach(row => this.selection.select(row));
    }

    goBackToStep1() {
        this.viewEngagements = false;
        this.dataSource = new MatTableDataSource<IExportData>();
        this.engCount = 0;
        this.clientCount = 0;
        this.loadEngGrid = true;
    }

    isClearEnabled(data) {
        return data.some(e => e.isChecked);
    }

    goBackToExportData() {
        this.goBack.emit(true);
    }

    ngOnDestroy(): void {
        this.unSubscribe$.next();
        this.unSubscribe$.complete();
    }
}
